/** 아주 작은 DOM 도우미. 문자열은 항상 textContent로 넣는다(서버 문구를 HTML로 해석하지 않음). */
type Child = Node | string | null | undefined | false;
type Attrs = Record<string, string | number | boolean | null | undefined | ((e: any) => void)>;

export function h<K extends keyof HTMLElementTagNameMap>(tag: K, attrs: Attrs = {}, ...children: (Child | Child[])[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (v === null || v === undefined || v === false) continue;
    if (typeof v === 'function') el.addEventListener(k.replace(/^on/, '').toLowerCase(), v);
    else if (k === 'class') el.className = String(v);
    else if (v === true) el.setAttribute(k, '');
    else el.setAttribute(k, String(v));
  }
  for (const c of children.flat()) {
    if (c === null || c === undefined || c === false) continue;
    el.append(typeof c === 'string' ? document.createTextNode(c) : c);
  }
  return el;
}

export function clear(el: Element): void {
  while (el.firstChild) el.removeChild(el.firstChild);
}

let toastTimer: ReturnType<typeof setTimeout> | null = null;
export function toast(text: string, ms = 3000): void {
  const root = document.getElementById('toast-root')!;
  clear(root);
  root.append(h('div', { class: 'toast', role: 'status', 'data-testid': 'toast' }, text));
  if (toastTimer !== null) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => clear(root), ms);
}
